import type { AnchorHTMLAttributes, FC } from 'react'

const BlankTargetLink: FC<AnchorHTMLAttributes<HTMLAnchorElement>> = (props) => (
  <a target="_blank" rel="noreferrer" {...props} />
)

export default BlankTargetLink
